import Home from "../views/Home.vue";
// import CourseVideo from "../views/CourseVideoDemo.vue";
import CourseVideo from "../views/CourseVideo.vue";
const PlusPlatform = () =>
  import(/* webpackChunkName: "plus" */ "@/views/PlusPlatform.vue");

export default [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/course/:courseId",
    name: "Course",
    component: CourseVideo,
    meta: {
      title: "课程"
    }
  },
  {
    path: "/course/:courseId/:chapterId/:sectionId",
    name: "CourseVideo",
    component: CourseVideo,
    meta: {
      title: "课程"
    }
  },
  {
    path: "/plus/:id",
    name: "PlusPlatform",
    component: PlusPlatform,
    meta: {
      title: "学习"
    }
  },
  {
    path: "/kongfu/:pathId/:taskId",
    name: "Kungfu",
    component: () => import("@/views/Kungfu.vue"),
    meta: {
      title: "练功房 Demo"
    }
  },
  {
    path: "/kongfu/:id",
    name: "Kongfu",
    component: () => import("@/views/Kongfu.vue"),
    meta: {
      title: "练功房"
    }
  },
  {
    path: "/kongfu/:pathId/project/:projectId",
    name: "KongfuProject",
    component: () => import("@/views/KongfuProject.vue"),
    meta: {
      title: "项目"
    }
  },
  {
    path: "/project/:projectId",
    name: "Project",
    component: () => import("@/views/Project/Project.vue"),
    meta: {
      title: "项目"
    }
  },
  {
    path: "*",
    name: "ErrorNotfound",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "error404" */ "../views/ErrorNotfound.vue")
  }
];
